module.exports = __webpack_public_path__ + "static/stars-dark-d913cde31f1bdf32186737f487944469.svg";